import { render } from "./FonteDeDadosPage.vue?vue&type=template&id=2c55d608&scoped=true"
import script from "./FonteDeDadosPage.vue?vue&type=script&lang=js"
export * from "./FonteDeDadosPage.vue?vue&type=script&lang=js"

import "./FonteDeDadosPage.vue?vue&type=style&index=0&id=2c55d608&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2c55d608"]])

export default __exports__